<template>
  <v-container id="schedule" fluid grid-list-lg>
    <v-layout row wrap justify-center>
      <v-flex xs12 xl8 lg10 md10 sm12 class="display-2 text-xs-center my-5">
        Schedule
        <v-divider insert></v-divider>
      </v-flex>
      <v-flex xs12 lg5 class="pr-3 pl-3 pt-0">
        <v-card>
          <v-card-text>
            <h4><b>The big day</b></h4>
            <location-card />
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 lg4 class="pr-3 pl-3 pt-0">
        <v-card>
          <v-card-text>
            <h4><b>The day after</b></h4>
            <after-location-card />
            <!-- <br> -->
            <!-- <v-card tile flat>
              <v-card-text>
                <p>
                  For all of those who can make it, Anan and I are planning on going to our favorite Boston Brewery, Night Shift located at <a href="https://www.google.com/maps/place/Night+Shift+Brewing+-+Everett/@42.4059707,-71.067886,15z/data=!4m2!3m1!1s0x0:0xc68b7f0434ddb595?sa=X&ved=2ahUKEwiw8o6M7_bkAhWuneAKHdJOAu4Q_BIwGHoECAkQCA" target="_blank">87 Santilli Hwy, Everett, MA 02149</a>.
                </p>
                <p>
                  They will have the <a href="https://www.complimentsfood.com/" target="_blank">Compliments Food Truck</a> there as well. We will be there starting at 12pm on Sunday until about 3 pm. Feel free to stop in at any point that you can make it.
                </p>
              </v-card-text>
            </v-card> -->
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xl4 md6 xs12 class="pa-3">
        <v-card>
          <v-img :src="require('../assets/photos/hero/invitation_hero_new.jpg')" />
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import LocationCard from '@/components/LocationCard.vue';
import AfterLocationCard from '@/components/AfterLocationCard.vue';

export default {
  name: 'Schedule',
  components: {
    LocationCard,
    AfterLocationCard,
  },
};
</script>

<style scoped>
h1 {
  text-align: center;
  font: 5rem sans-serif;
}
h2 {
  text-align: center;
  font: 3.5rem sans-serif;
}
h3 {
  text-align: center;
  font: 3rem sans-serif;
}
h4 {
  text-align: center;
  font: 2rem sans-serif;
}
h5 {
  text-align: center;
  font: 1.4rem sans-serif;
}
h6 {
  text-align: center;
  font: 1rem sans-serif;
}
</style>
